var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-bar"},[_c('logo'),_c('el-menu',{staticClass:"side-menu",attrs:{"default-active":_vm.currentPage}},[_c('sub-menu',{attrs:{"subMenu":_vm.subMenu}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }